import { render, staticRenderFns } from "./MenuReportReward.vue?vue&type=template&id=6450dba9&scoped=true&"
import script from "./MenuReportReward.vue?vue&type=script&lang=js&"
export * from "./MenuReportReward.vue?vue&type=script&lang=js&"
import style0 from "./MenuReportReward.vue?vue&type=style&index=0&id=6450dba9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6450dba9",
  null
  
)

export default component.exports